export const useFile = () => {
    const saveFile = (content: File | Blob, file_name: string) => {
        const download_url = window.URL.createObjectURL(content)
        const link = document.createElement('a')
        link.href = download_url
        link.setAttribute('download', file_name)
        document.body.appendChild(link)
        link.click()
        link.remove()
    }

    const saveFileByURL = (download_url: string, file_name?: string) => {
        const link = document.createElement('a')
        link.href = download_url
        link.download = file_name || 'file'
        link.target = '_blank'
        document.body.appendChild(link)
        link.click()
        link.remove()
    }

    return { saveFile, saveFileByURL }
}
